var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHezaizuhe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4795"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 692",
    d: "M6.03125 12.625V1.65625H11.4688V12.625",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631343",
    x: 3.625,
    y: 12.9062,
    width: 4.375,
    height: 1.96875,
    fill: "#C2C2C2",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631344",
    x: 9.5,
    y: 12.9062,
    width: 4.375,
    height: 1.96875,
    fill: "#C2C2C2",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 4793"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 687",
    d: "M16.75 7.1405H12.901",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 13",
    d: "M12.2339 7.14064L14.2463 5.3544L14.2463 8.92688L12.2339 7.14064Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 4794"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 687_2",
    d: "M0.75 7.14075L4.59899 7.14075",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 13_2",
    d: "M5.26611 7.14061L3.25374 8.92685L3.25374 5.35437L5.26611 7.14061Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHezaizuhe);
export default __webpack_public_path__ + "static/media/hezaizuhe.5d5234989242c9adf22fc24ba9b3e3cd.svg";
export { ForwardRef as ReactComponent };